module.exports = __webpack_public_path__ + "static/assets/5e0704b815761d38242f1b961ce9ef69.mp3";